import { Modal } from '@mui/material';
import React from 'react';
import './ModalEliminarModelo.scss';

interface IPropsModalEliminarModelo {
    open: boolean;
    onDelete: () => void;
    onCancelDelete: () => void;
}

const ModalEliminarModelo: React.FunctionComponent<IPropsModalEliminarModelo> = ({
    open,
    onDelete,
    onCancelDelete,
}) => {
    return (
        <Modal sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} open={open}>
            <div className="modaleliminar">
                <h1>¿Eliminar modelo?</h1>
                <p>
                    Esta acción eliminará el modelo, pero las evaluaciones realizadas seguirán disponibles en tu panel.
                </p>
                <div className="modaleliminar-actions">
                    <button className="delete-button" onClick={onDelete}>
                        Eliminar modelo
                    </button>
                    <button className="primary-button" onClick={onCancelDelete}>
                        Conservar modelo
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalEliminarModelo;
